import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import type {ReferralSetting} from 'src/types/referral-v2';
import {
  INITIAL_REFERRAL_SETTINGS,
  getRadioSelectOption,
  getRadioChoiceOption,
} from 'src/utils/referral-v2';

import {SubTitleSmall} from '@spaced-out/ui-design-system/lib/components/Text';
import {SimpleDropdown} from '@spaced-out/ui-design-system/lib/components/Dropdown';
import {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu';
import {
  Card,
  CardHeader,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';
import PayoutRule from 'src/components/referral-v2/payout-rule/payout-rule';
import css from 'src/components/referral-v2/configure/configure.css';


const ReferralAdvanceSettings = ({
  referralSettings,
}: {
  referralSettings: ReferralSetting | null | undefined;
}) => {
  const {t} = useLabelTranslation();
  const radioSelectOption = getRadioSelectOption(t);
  const radioChoiceOption = getRadioChoiceOption(t);
  const {
    duplicate_profile_check_method,
    reward_for_existing_referral,
    should_pay_for_different_role,
  } =
    referralSettings?.one_time_settings ||
    INITIAL_REFERRAL_SETTINGS.one_time_settings;

  return (
    <Card
      // @ts-expect-error - TS2769 - No overload matches this call.
      type="primary"
      classNames={{wrapper: css.generalNotificationsContent}}
    >
      <CardHeader>
        <SubTitleSmall>
          {t('One_Time_Settings', 'One Time Settings')}
        </SubTitleSmall>
      </CardHeader>
      <CardContent className={css.contentSection}>
        <InContextAlert
          semantic="information"
          leftIconName="circle-info"
          classNames={{wrapper: css.defaultMargin}}
        >{`${t(
          'Onetime_settings_will_be_locked_upon_saving_the_changes_You_would_need_to_contact_support_to_make_any_further_changes',
          'One-time settings will be locked upon saving the changes. You would need to contact support to make any further changes',
        )}.`}</InContextAlert>
        <PayoutRule disabled={true} />
        <div className={css.defaultMargin}>
          <SingleSelectDropdown
            value={duplicate_profile_check_method}
            options={radioSelectOption}
            disabled={true}
            label={`${t(
              'What_will_be_used_as_the_duplicate_check_for_new_referrals_in_the_ATS',
              'What will be used as the duplicate check for new referrals in the ATS',
            )}?`}
          />
        </div>
        <div className={css.defaultMargin}>
          <SingleSelectDropdown
            value={reward_for_existing_referral?.toLocaleString()}
            options={radioChoiceOption}
            label={`${t(
              'Do_you_want_to_allow_referral_submission_if_the_candidate_is_already_exists_in_your_database',
              'Do you want to allow referral submission if the candidate is already exists in your database',
            )}?`}
            disabled={true}
          />
        </div>
        <div className={css.defaultMargin}>
          <SingleSelectDropdown
            value={should_pay_for_different_role.toLocaleString()}
            options={radioChoiceOption}
            label={`${t(
              'Is_a_referral_eligible_for_payout_if_hired_for_a_different_job_role',
              'Is a referral eligible for payout if hired for a different job role',
            )}?`}
            disabled={true}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralAdvanceSettings;

type SingleSelectDropdownProps = {
  label: string;
  options?: MenuOption[];
  value?: string;
  disabled?: boolean;
  onChangeOption?: (value: string) => unknown;
};
export const SingleSelectDropdown = ({
  value,
  options = [],
  label,
  disabled = false,
  onChangeOption,
}: SingleSelectDropdownProps) => {
  const {t} = useLabelTranslation();
  const radioChoiceOption = getRadioChoiceOption(t);
  const dropdownOptions = options.length > 0 ? options : radioChoiceOption;
  return (
    <div className={css.questionContainer}>
      <div className={css.radioOptions}>
        <SimpleDropdown
          classNames={{box: css.roundedSelect}}
          label={label}
          options={dropdownOptions}
          selectedKeys={value ? [value] : []}
          // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'ChangeEvent<HTMLInputElement> | MenuOption'.
          onChange={(option) => onChangeOption?.(option.key)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
